
export default {
  props: {
    diagram: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    slides: []
  }),
  fetchOnServer: false,
  async fetch () {
    let page = 1
    while (true) {
      const response = await this.$serverBackend.get(`/diagrams/${this.diagram.id}/images/`, { page });
      this.slides = [...this.slides, ...response.results]
      if (!response.next) {
        break
      }
      page++
    }
  }
}
